export default "__VITE_ASSET__CC38iLRF__"